import { motion } from "framer-motion";
import { X } from "lucide-react";
import { ContactForm } from "@/components/ContactForm";

export const ContactModal = ({ onClose }) => {
  const closeFromBackdrop = (event) => { if (event.target === event.currentTarget) onClose(); };
  return (
    <motion.div className="modal-backdrop contact-backdrop" role="presentation" onClick={closeFromBackdrop} data-testid="contact-modal-backdrop" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <motion.section className="feature-modal contact-modal" role="dialog" aria-modal="true" aria-labelledby="contact-modal-title" data-testid="contact-modal" initial={{ opacity: 0, scale: .94, y: 12 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: .96, y: 8 }} transition={{ duration: .22 }}>
        <button className="modal-close" type="button" aria-label="Close contact form" onClick={onClose} data-testid="contact-modal-close-button"><X aria-hidden="true" /></button>
        <ContactForm onSuccessClose={onClose} modal />
      </motion.section>
    </motion.div>
  );
};